import { Injectable } from '@angular/core';
  
import { Globals } from '../globals';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
@Injectable()
export class ForgetPasswordService {

  constructor(private globals: Globals, public router: Router) { }






}

